import { z } from "zod";
import { STORY_GRAPH_ISSUE_CODE_VALUES } from "../../constants/story-graph-issue.js";
import { EndingDefinitionSchema, EndingRuleSchema } from "./ending.js";
import { StoryFlagDefSchema } from "./flags.js";
import { NodeSchema } from "./node.js";
import { GraphShotSchema } from "./shot.js";
export const StoryGraphDefinitionSchema = z.object({
    entryNodeId: z.uuid(),
    flags: z.array(StoryFlagDefSchema),
    nodes: z.array(NodeSchema).min(1),
    shots: z.array(GraphShotSchema),
    endings: z.array(EndingDefinitionSchema).min(1),
    endingRules: z.array(EndingRuleSchema),
});
export const StoryGraphIssueSchema = z.object({
    code: z.enum(STORY_GRAPH_ISSUE_CODE_VALUES),
    message: z.string(),
    subjectId: z.string().nullable(),
});
